export enum Status {
    Active = "ACTIVE",
    Suspended = "SUSPENDED",
}
